<template>
  <div>
    <div class="selected-filter-dimension"></div>
    <vxe-table size="mini" border :row-config="{useKey: true}" :data="value" v-if="value.length">
      <vxe-column field="datasourceName" title="数据源" show-overflow></vxe-column>
      <vxe-column field="tableName" title="数据集" show-overflow>
        <template #default="{row}">
          {{ row.tableName || '-' }}
        </template>
      </vxe-column>
      <vxe-column field="dimensionName" title="维度" show-overflow></vxe-column>
    </vxe-table>
    <a-button class="ml--8" type="link" @click="showDrawer"
    ><icon-font type="icon-plus-square" />设置筛选维度</a-button>
    <a-drawer
      class="filter-condition"
      title="设置筛选维度"
      placement="bottom"
      :visible="visible"
      @close="visible = false"
      destroyOnClose
      height="50%"
    >
      <div class="condition-box">
        <div v-for="(v, i) in list" :key="i">
          <chooseFieldsItem
            :dataSet="dataSet"
            :list="list"
            :index="i"
            @delete="() => deleteClick(i)"
          ></chooseFieldsItem>
        </div>
      </div>
      <a-button type="link" @click="addClick"
        ><icon-font type="icon-plus-square"></icon-font
        ><span>添加维度</span></a-button
      >
      <div class="bottom-btn">
        <a-button @click="visible = false">取消</a-button>
        <a-button type="primary" @click="save">保存</a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import {
  getDimensionList,
  getFieldsByCode,
  getNormList,
  getDataSource,
  getFields
} from "@/api/basicCyberData";
import chooseFieldsItem from "./chooseFieldsItem.vue";

export default {
  name: "chooseFields",
  props: ["value"],
  data() {
    return {
      visible: false,
      list: [],
      dataSet: [], // 数据源
      opObj: {
        like: '包含',
        notLike: '不包含',
        startWith: '开始以',
        notStartWith: '开始不是以',
        endWith: '结束以',
        notEndWith: '结束不是以',
        eq: '等于',
      }
    };
  },
  components: {
    chooseFieldsItem,
  },
  mounted() {
    this.echoDataSet();
  },
  methods: {
    async echoDataSet(val) {
      this.list = JSON.parse(JSON.stringify(this.value || []))
      await this.loadDataSet()
    },
    async loadDataSet() {
      const { code, data } = await getDataSource();
      this.dataSet = data;
      if (code != "200") return;
    },
    showDrawer() {
      this.visible = true
      this.init(this.value)
    },
    init(list) {
      this.visible = true;
      if (list && list.length) {
        this.list = JSON.parse(JSON.stringify(this.value || []))
      } else {
        this.list = list.length
          ? list
          : [
              {
                op: 'like',
                id: undefined,
                dimension: undefined,
                dimensionName: undefined,
                tableId: undefined,
                tableName: undefined,
                datasource: undefined,
                datasourceName: undefined,
              },
            ];
      }
    },
    save() {
      for (let i = 0; i < this.list.length; i++) {
        const obj = this.list[i];
        if (!obj.dimension) {
          this.$message.error("请选择筛选维度！");
          return;
        }
        if (!obj.op) {
          this.$message.error("请选择运算符！");
          return;
        }
      }
      console.log(this.list)
      this.$emit("change", this.list);
      this.visible = false;
    },
    addClick() {
      this.list.push({
        op: 'like',
        id: undefined,
        dimension: undefined,
        dimensionName: undefined,
        tableId: undefined,
        tableName: undefined,
        datasource: undefined,
        datasourceName: undefined,
      });
    },
    deleteClick(i) {
      let a = JSON.parse(JSON.stringify(this.list))
      a.splice(i, 1)
      this.list = []
      this.$nextTick(() => {
        this.list = a
      })
    },
  },
};
</script>
<style lang="less" scoped>
.selected-filter-dimension {
  margin-top: -20px;
  padding-left: 10px;
  .selected-filter-dimension-item {
    margin-bottom: 3px;
    & > * {
      margin-right: 10px;
    }
  }

}
.condition-accourd {
  margin-bottom: 12px;
  .ant-select {
    width: 76px;
    margin: 0px 8px;
    background: #f3f6fe;
    border-radius: 6px;
    color: #2d3446;
    font-size: 14px;
    font-weight: 400;
    /deep/ .ant-select-selection {
      border: 0;
      background-color: transparent;
      box-shadow: none;
    }
  }
}
.condition-box {
  max-height: calc(100% - 72px);
  overflow: auto;
}
</style>
<style lang="less">
.filter-condition {
  .ant-drawer-body {
    height: calc(100% - 55px);
    box-sizing: border-box;
    position: relative;
    .bottom-btn {
      position: absolute;
      bottom: 10px;
      right: 16px;
      & > * {
        margin-left: 8px;
      }
    }
  }
}
</style>